import { useCallback } from "react"
import { restakingAccountAtom } from "@/atoms/restakingState"
import { SKELETON_VALUE } from "@/utils/constants"
import { formatToken } from "@/utils/numberFormatter"
import { Button, Stack, Typography } from "@mui/material"
import { useAtomValue } from "jotai"
import { useRouter } from "next/router"
import Image from "next/image"
import OpenIcon from "@/assets/icons/open.svg"
import useRestaking from "@/hooks/useRestaking"
import useTrans from "@/hooks/useTrans"

const StakeAndEarn = () => {
  const trans = useTrans()
  const router = useRouter()
  const restakingAccount = useAtomValue(restakingAccountAtom)

  const { stakedAmountUI } = useRestaking()

  const handleRedirectMyStaking = useCallback(() => {
    router.push("/staking")
  }, [router])

  const totalStakedDisplay = restakingAccount ? formatToken(stakedAmountUI) : SKELETON_VALUE

  return (
    <Stack gap={0.5}>
      <Typography className='text-sm text-neutral-600 flex gap-1 items-center'>
        {trans.dashboard.hero.stake_and_earn}
      </Typography>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <Typography className='font-semibold text-base text-orange-600'>
          {totalStakedDisplay} <span className='text-neutral-600 text-sm font-normal'>REL</span>
        </Typography>
        <Button
          onClick={handleRedirectMyStaking}
          className='p-1 cursor-pointer text-xs hover:bg-transparent text-primary underline hover:underline hover:text-primary/80 disabled:opacity-60 disabled:text-primary z-10'
        >
          <Image className='mr-1 inline' src={OpenIcon} alt='click-icon' width={16} height={16} />
          {trans.dashboard.hero.my_staking}
        </Button>
      </Stack>
    </Stack>
  )
}

export default StakeAndEarn
